var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"20px","height":"20px","border-radius":"100%"},style:(_vm.colorStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }